import angular from 'angular';
import FeaturedProductsComponent from './featured-products.component';

let FeaturedProductsModule = angular.module('catalog.featuredProducts', [])
  .component('featuredProducts', FeaturedProductsComponent);

export default FeaturedProductsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/featured-products/featured-products.js
 **/